import _Object$assign from 'babel-runtime/core-js/object/assign';
import _regeneratorRuntime from 'babel-runtime/regenerator';
import _extends from 'babel-runtime/helpers/extends';
import _asyncToGenerator from 'babel-runtime/helpers/asyncToGenerator';

/* eslint-disable max-lines */
import _ from 'lodash';
import { parseTime } from '@/filters/index';
import SearchBar from '@/components/SearchV3/index.vue';
import ActionBar from '@/components/ActionBar/index';
import searchMixin from '@/mixin/search';
import TableList from '../components/table.vue';
import Pagination from '@/components/Pagination/index.vue';
import DialogForm from '@/components/DialogForm/index.vue';
import previewModal from '@/components/PreviewModal/index.vue';
import { fetchCreativeList, deleteCase, publishCase, creatCase, updateCreative } from '@/api/website/creative';
import { langType, casesType, caseTag, logoPosition, uploadType, orientationConfig } from '../config';

export default {
  components: {
    ActionBar: ActionBar,
    SearchBar: SearchBar,
    TableList: TableList,
    Pagination: Pagination,
    previewModal: previewModal,
    DialogForm: DialogForm
  },
  mixins: [searchMixin],
  data: function data() {
    return {
      query: {
        order: '-id,name',
        page: 1,
        page_size: 15
      },
      pagination: {
        total: 0
      },
      listLoading: false,
      list: [],
      formItemList: [{
        type: 'select',
        prop: 'lang',
        params: {
          disabled: false,
          readonly: false,
          placeholder: '请输入语言版本',
          options: langType
        }
      }, {
        type: 'select',
        prop: 'type',
        params: {
          disabled: false,
          readonly: false,
          placeholder: '请输入作品类型',
          options: casesType
        }
      }, {
        type: 'input',
        prop: 'keyword',
        subtype: 'text',
        params: {
          clearable: true,
          placeholder: '请输入作品名称'
        }
      }, {
        type: 'select',
        prop: 'labels',
        params: {
          multiple: true,
          options: caseTag,
          placeholder: '请输入作品标签'
        }
      }],
      columnConfig: ['id', 'lang', 'name', 'type', 'labels', 'thumb_url', 'publish_time', 'updated_time', 'setting-cell', 'action-cell'],
      previewDialog: {
        visible: false,
        title: '',
        html_url: '',
        showMwUrl: false,
        defaultUrl: false
      },
      dialog: {
        config: {
          title: '添加作品',
          visible: false,
          loading: false,
          inputType: 'create',
          edit: true
        },
        formConfig: {
          labelPosition: 'left',
          labelWidth: '150px'
        },
        value: {
          queryId: '',
          name: '',
          e_name: '',
          lang: '',
          type: '',
          basic_id: '',
          orientation: '',
          file_url: '',
          case_upload_type: '',
          watermark_position: '',
          thumb_url: '',
          e_blog_url: '',
          labels: [],
          publish_time: parseTime(new Date(), '{y}-{m}-{d} {h}:{i}:{s}')
        },
        fileList: [],
        caseFileList: [],
        coverFileList: []
      },
      editRowData: {}
    };
  },

  watch: {
    $route: function $route(to, from) {
      console.log(this.query);
      this.getList(this.query);
    },
    'dialog.config.visible': function dialogConfigVisible(val) {
      if (!val) {
        this.resetDialog();
      }
    },
    'dialog.value.type': function dialogValueType(newVal, oldVal) {
      if (newVal && oldVal) {
        this.dialog.value.file_url = '';
        this.dialog.caseFileList = [];
      }
    },
    'dialog.value.file_url': function dialogValueFile_url(val) {
      if (this.$refs['dialog-form'].$refs['form']) {
        this.$refs['dialog-form'].$refs['form'].validateField('file_url');
      }
    },
    'dialog.value.thumb_url': function dialogValueThumb_url(val) {
      if (this.$refs['dialog-form'].$refs['form']) {
        this.$refs['dialog-form'].$refs['form'].validateField('thumb_url');
      }
    }
  },
  computed: {
    tableConfig: function tableConfig() {
      var config = {};
      if (this.$route.query && this.$route.query.order) {
        config = {
          'default-sort': {
            prop: this.$route.query.order.replace('-', ''),
            order: this.$route.query.order.indexOf('-') !== -1 ? 'descending' : 'ascending'
          }
        };
      } else {
        config = {};
      }
      return config;
    },
    dialogItem: function dialogItem() {
      var _this = this;

      return [{
        label: '语言版本',
        prop: 'lang',
        type: 'radio-group',
        params: {
          options: langType
        },
        rules: [{
          required: true,
          message: '请选择语言版本',
          trigger: 'change'
        }]
      }, {
        visible: function visible(_ref) {
          var formValue = _ref.formValue;

          return formValue.lang !== 2;
        },
        label: '作品名称（zh）',
        type: 'input',
        prop: 'name',
        rules: [{
          required: true,
          message: '请输入作品名称',
          trigger: 'change'
        }, {
          min: 1,
          max: 50,
          message: '名称不能超过 50 个字符',
          trigger: 'change'
        }]
      }, {
        visible: function visible(_ref2) {
          var formValue = _ref2.formValue;

          return formValue.lang !== 1;
        },
        label: '作品名称（en）',
        type: 'input',
        prop: 'e_name',
        rules: [{
          required: true,
          message: '请输入作品名称',
          trigger: 'change'
        }, {
          min: 1,
          max: 50,
          message: '名称不能超过 50 个字符',
          trigger: 'change'
        }]
      }, {
        label: '作品类型',
        prop: 'type',
        type: 'radio-group',
        params: {
          options: casesType,
          handleChange: function handleChange(val) {
            _this.dialog.value.labels = [];
          }
        },
        rules: [{
          required: true,
          message: '请选择作品类型',
          trigger: 'change'
        }]
      }, {
        label: '作品标签',
        type: 'select',
        prop: 'labels',
        params: {
          multiple: true,
          placeholder: '请输入作品标签',
          options: this.getCaseTagOptions()
        },
        rules: [{
          required: true,
          message: '请选择作品类型',
          trigger: 'change'
        }]
      }, {
        visible: function visible(_ref3) {
          var formValue = _ref3.formValue;

          return formValue.type === 2;
        },
        label: '互动广告上传方式',
        prop: 'case_upload_type',
        type: 'radio-group',
        rules: [{
          required: true,
          message: '请选择上传作品方式',
          trigger: 'change'
        }],
        params: {
          options: uploadType
        }
      }, {
        visible: function visible(_ref4) {
          var formValue = _ref4.formValue;

          return formValue.case_upload_type === 1 && formValue.type === 2;
          // return !formValue.source_id && formValue.choose_base === 1 && formValue.source_type !== 3
        },
        label: '',
        type: 'business',
        subtype: 'basic-pack-selector',
        prop: 'basic_id',
        params: {
          width: '100%'
        },
        rules: [{
          required: true,
          message: '请选择基础包',
          trigger: 'change'
        }]
      }, {
        visible: function visible(_ref5) {
          var formValue = _ref5.formValue;

          return formValue.case_upload_type === 2 || formValue.type === 1;
        },
        label: '上传作品',
        type: 'business',
        subtype: 'file-uploader',
        prop: 'file_url',
        rules: [{
          required: true,
          message: '请选择上传作品',
          trigger: 'change'
        }],
        params: function params() {
          var acceptType = '';
          var tip = '';
          // 创意视频
          if (_this.dialog.value.type === 1) {
            acceptType = ['mp4'];
            tip = '仅支持mp4格式视频，推荐视频比例：16: 9，9：16，建议尺寸：750x1334px 、1334x750px，大小:  30M以内';
          } else {
            acceptType = ['zip'];
            tip = '手动上传基础包，仅支持zip格式，大小:  30M以内';
          }
          var temp = {
            disabled: false,
            drag: true,
            data: {
              local: 1,
              mod: 'website'
            },
            'with-credentials': true,
            acceptType: acceptType,
            tip: tip,
            style: 'width: 400px;',
            fileList: _this.dialog.caseFileList
          };
          return temp;
        },
        beforeUpload: this.beforeUpload,
        handleUploadSuccess: this.handleUploadSuccess,
        handleRemove: this.handleRemove
      }, {
        label: '展示方式',
        prop: 'orientation',
        type: 'radio-group',
        rules: [{
          required: true,
          message: '请选择展示方式',
          trigger: 'change'
        }],
        params: {
          options: orientationConfig
        }
      }, {
        label: '作品缩略图：',
        type: 'business',
        subtype: 'file-uploader',
        prop: 'thumb_url',
        rules: [{
          required: true,
          message: '请上传图片',
          trigger: 'change'
        }],
        params: function params() {
          var acceptType = ['jpg', 'png', 'jpeg'];
          var tip = '仅支持jpg, png, jpeg格式图片，推荐图片比例：16: 9，大小:  500kb以内';
          var temp = {
            disabled: false,
            drag: true,
            data: {
              local: 1,
              mod: 'website'
            },
            'with-credentials': true,
            acceptType: acceptType,
            tip: tip,
            style: 'width: 400px;',
            fileList: _this.dialog.coverFileList
          };
          return temp;
        },
        beforeUpload: this.beforeUpload,
        handleUploadSuccess: this.handleCoverUploadSuccess,
        handleRemove: this.handleCoverRemove
      }, {
        visible: function visible(_ref6) {
          var formValue = _ref6.formValue;

          return formValue.type === 1;
        },
        label: '水印位置',
        type: 'radio-group',
        prop: 'watermark_position',
        params: {
          options: logoPosition
        },
        rules: [{
          required: true,
          message: '请选择水印位置',
          trigger: 'change'
        }]
      }, {
        label: '发布时间',
        type: 'date-picker',
        prop: 'publish_time',
        subtype: 'datetime',
        params: {
          format: 'yyyy-MM-dd HH:mm:ss',
          valueFormat: 'yyyy-MM-dd HH:mm:ss',
          pickerOptions: {}
        },
        rules: [{
          required: true,
          message: '请选择发布时间',
          trigger: 'change'
        }]
      }, {
        visible: function visible(_ref7) {
          var formValue = _ref7.formValue;

          return formValue.lang !== 2;
          // return !formValue.source_id && formValue.choose_base === 1 && formValue.source_type !== 3
        },
        label: '关联博客地址（zh）',
        type: 'input',
        prop: 'blog_url'
      }, {
        visible: function visible(_ref8) {
          var formValue = _ref8.formValue;

          return formValue.lang !== 1;
          // return !formValue.source_id && formValue.choose_base === 1 && formValue.source_type !== 3
        },
        label: '关联博客地址（en）',
        type: 'input',
        prop: 'e_blog_url'
      }];
    }
  },
  mounted: function mounted() {
    this.getList(this.query);
  },

  methods: {
    getList: function getList(query) {
      var _this2 = this;

      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var labels, postData, res;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                labels = query.labels;

                query.labels = query.labels ? query.labels.join() : [];
                console.log(_this2.formItemList[3]);
                postData = _extends({}, query);

                console.log(postData);
                // 固定search_field值
                if (postData.keyword) postData.search_field = 'name';
                // 更新时间
                _context.prev = 6;

                _this2.listLoading = true;
                _context.next = 10;
                return fetchCreativeList(postData);

              case 10:
                res = _context.sent;

                query.labels = labels;
                _this2.listLoading = false;
                _this2.list = _.get(res, 'data.data.list', []);
                _this2.pagination.total = _.get(res, 'data.data.total', 0);
                _context.next = 20;
                break;

              case 17:
                _context.prev = 17;
                _context.t0 = _context['catch'](6);

                _this2.listLoading = false;
                //

              case 20:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this2, [[6, 17]]);
      }))();
    },
    handleDelete: function handleDelete(_ref9) {
      var _this3 = this;

      var row = _ref9.row;

      this.$confirm('是否确认删除当前案例？', '提示', {
        type: 'warning'
      }).then(function () {
        _this3.deleteCaseItem(row);
      }).catch(function () {
        //
      });
    },

    // 授权官网展示
    publishCaseItem: function publishCaseItem(_ref10) {
      var _this4 = this;

      var row = _ref10.row;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        var res;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return publishCase(row.id, {
                  status: row.status === 1 ? 2 : 1
                });

              case 2:
                res = _context2.sent;

                if (_.get(res, 'data.code', '') === 0) {
                  _this4.$message({
                    message: '处理成功',
                    type: 'success'
                  });
                } else {
                  _this4.$message(_.get(res, 'data.msg', ''));
                }
                _this4.getList(_this4.query);

              case 5:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this4);
      }))();
    },

    // 弹窗内作品标签根据作品类型展示
    getCaseTagOptions: function getCaseTagOptions() {
      if (this.dialog.value.type === 1) {
        return caseTag.slice(0, 4);
      } else if (this.dialog.value.type === 2) {
        return caseTag.slice(4, 8);
      }
      return caseTag.slice(8);
    },

    // 填充弹窗内容
    fillDialog: function fillDialog(row) {
      var obj = _.pick(row, ['lang', 'name', 'type', 'e_name', 'basic_id', 'thumb_url', 'publish_time', 'blog_url', 'orientation', 'e_blog_url', 'file_url', 'labels', 'watermark_position']);
      obj.publish_time = parseTime(new Date(obj.publish_time).getTime(), '{y}-{m}-{d} {h}:{i}:{s}');
      obj.basic_id = obj.basic_id ? obj.basic_id : '';
      obj.labels = obj.labels ? obj.labels.split(',').map(function (value) {
        return Number(value, 10);
      }) : [];
      if (!obj.watermark_position) {
        obj.watermark_position = '';
      }
      _Object$assign(this.editRowData, obj);
      obj.queryId = row.id;
      // 案例类型，交互游戏
      if (obj.type === 2) {
        // 案例上传方式
        obj.case_upload_type = obj.basic_id ? 1 : 2;
      }
      if (obj.thumb_url) {
        this.dialog.coverFileList = [{
          name: row.thumb_name,
          url: row.thumb_url
        }];
      }
      if (obj.file_url) {
        this.dialog.caseFileList = [{
          name: row.file_name,
          url: row.file_url
        }];
      }
      _Object$assign(this.dialog.value, obj);
    },
    handleSortChange: function handleSortChange(_ref11) {
      var column = _ref11.column,
          prop = _ref11.prop,
          order = _ref11.order;

      if (order) {
        this.query.order = (order === 'descending' ? '-' : '') + prop;
      } else {
        this.query.order = '-id,name';
      }
      this.$router.push({
        query: this.query
      });
    },

    // 提交案例（创建，提交）
    submitCase: function submitCase() {
      var postData = {};
      // 版本名称
      if (this.dialog.value.lang === 1) {
        _Object$assign(postData, _.pick(this.dialog.value, ['name']));
      } else if (this.dialog.value.lang === 2) {
        _Object$assign(postData, _.pick(this.dialog.value, ['e_name']));
      } else if (this.dialog.value.lang === 3) {
        _Object$assign(postData, _.pick(this.dialog.value, ['name', 'e_name']));
      }
      // 创意视频水印
      if (this.dialog.value.type === 1) {
        _Object$assign(postData, _.pick(this.dialog.value, ['watermark_position']));
      }
      // 互动广告，基础包上传
      if (this.dialog.value.type === 2 && this.dialog.value.case_upload_type === 1) {
        _Object$assign(postData, _.pick(this.dialog.value, ['basic_id']));
      } else {
        _Object$assign(postData, _.pick(this.dialog.value, ['file_url']));
      }
      // 其他公共参数
      _Object$assign(postData, _.pick(this.dialog.value, ['lang', 'type', 'labels', 'thumb_url', 'publish_time', 'blog_url', 'e_blog_url', 'orientation']));
      if (postData.labels.length > 0) {
        postData.labels = postData.labels.join();
      } else {
        postData.labels = '';
      }
      if (this.dialog.config.inputType === 'create') {
        this.handleCreateCase(postData);
      } else {
        this.handleUpdateCase(postData);
      }
    },
    handleCreateCase: function handleCreateCase(postData) {
      var _this5 = this;

      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
        var res;
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _this5.dialog.config.loading = true;
                _context3.prev = 1;
                _context3.next = 4;
                return creatCase(postData);

              case 4:
                res = _context3.sent;

                _this5.dialog.config.loading = false;
                if (_.get(res, 'data.code', '') === 0) {
                  _this5.getList(_this5.query);
                  _this5.dialog.config.visible = false;
                  _this5.$message({
                    message: '添加成功',
                    type: 'success'
                  });
                } else {
                  _this5.$message(_.get(res, 'data.msg', ''));
                }
                _context3.next = 12;
                break;

              case 9:
                _context3.prev = 9;
                _context3.t0 = _context3['catch'](1);

                _this5.dialog.config.loading = false;

              case 12:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this5, [[1, 9]]);
      }))();
    },
    handleUpdateCase: function handleUpdateCase(postData) {
      var _this6 = this;

      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4() {
        var omitPostData, key, res;
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _this6.dialog.config.loading = true;
                _context4.prev = 1;
                omitPostData = {};
                // 遍历对比json

                for (key in postData) {
                  if (postData[key] !== _this6.editRowData[key]) {
                    omitPostData[key] = postData[key];
                  }
                }
                _context4.next = 6;
                return updateCreative(_this6.dialog.value.queryId, omitPostData);

              case 6:
                res = _context4.sent;

                _this6.dialog.config.loading = false;
                if (_.get(res, 'data.code', '') === 0) {
                  _this6.getList(_this6.query);
                  _this6.dialog.config.visible = false;
                  _this6.$message({
                    message: '更新成功',
                    type: 'success'
                  });
                } else {
                  _this6.$message(_.get(res, 'data.msg', ''));
                }
                _context4.next = 15;
                break;

              case 11:
                _context4.prev = 11;
                _context4.t0 = _context4['catch'](1);

                console.log(_context4.t0);
                _this6.dialog.config.loading = false;

              case 15:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, _this6, [[1, 11]]);
      }))();
    },

    // 重置设置弹窗内容
    resetDialog: function resetDialog() {
      // 清空弹窗输入值
      for (var key in this.dialog.value) {
        console.log(key);
        this.$set(this.dialog.value, key, '');
      }
      this.dialog.value['publish_time'] = parseTime(new Date(), '{y}-{m}-{d} {h}:{i}:{s}');
      // 清空上传列表
      this.dialog.caseFileList = [];
      this.dialog.coverFileList = [];
    },

    // 展示dialog
    showDialog: function showDialog(type, row) {
      var _this7 = this;

      this.dialog.config.inputType = type;
      this.dialog.config.visible = true;
      this.$nextTick(function () {
        if (type === 'edit') {
          _this7.fillDialog(row);
        }
      });
    },
    handlePreview: function handlePreview(_ref12) {
      var row = _ref12.row;

      this.previewDialog.visible = true;
      this.previewDialog.title = row.name || row.e_name;
      this.previewDialog.html_url = (row.html_url || row.file_url) + '?loading=2&logo=2';
    },
    handleEdit: function handleEdit(_ref13) {
      var row = _ref13.row;

      this.dialog.config.title = '\u7F16\u8F91\uFF1A' + (row.name || row.e_name);
      this.showDialog('edit', row);
    },
    handleCreat: function handleCreat() {
      this.dialog.config.title = '\u6DFB\u52A0\u4F5C\u54C1';
      this.dialog.value.type = 1;
      this.showDialog('create');
    },
    deleteCaseItem: function deleteCaseItem(row) {
      var _this8 = this;

      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5() {
        var res;
        return _regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _context5.next = 2;
                return deleteCase(row.id, {});

              case 2:
                res = _context5.sent;

                if (_.get(res, 'data.code', '') === 0) {
                  _this8.$message({
                    message: '删除成功',
                    type: 'success'
                  });
                } else {
                  _this8.$message(_.get(res, 'data.msg', ''));
                }
                _this8.getList(_this8.query);

              case 5:
              case 'end':
                return _context5.stop();
            }
          }
        }, _callee5, _this8);
      }))();
    },
    beforeUpload: function beforeUpload(file) {
      var isPIC = ['jpg', 'png', 'jpeg'].some(function (item) {
        return file.type.indexOf(item) !== -1;
      });
      var isMP4 = ['mp4'].some(function (item) {
        return file.type.indexOf(item) !== -1;
      });
      var isZIP = ['zip'].some(function (item) {
        return file.type.indexOf(item) !== -1;
      });
      var isLt500 = file.size / 1024 < 500;
      var isLt30M = file.size / 1024 / 1024 < 30;
      if (isPIC && !isLt500) {
        this.$message.error('上传图片不能超过500kb');
        return isPIC && isLt500;
      }
      if (isMP4 && !isLt30M) {
        this.$message.error('上传视频不能超过30MB');
        return isMP4 && isLt30M;
      }
      if (isZIP && !isLt30M) {
        this.$message.error('上传基础包不能超过30MB');
        return isZIP && isLt30M;
      }
      return true;
    },
    handleUploadSuccess: function handleUploadSuccess(response, file, fileList) {
      // 只有在上传弹框是可视的情况下才执行后续逻辑
      if (!this.dialog.config.visible) return;
      if (response.code === 0) {
        // 当上传的图片都成功之后，为file_path赋值
        this.dialog.caseFileList = [{
          name: response.data.origin_name,
          url: response.data.url
        }];
        // 当上传的图片都成功之后，为file_path赋值
        this.dialog.value.file_path = response.data.file_path;
      } else {
        console.log(file);
        file.status = 'fail';
        this.$message({
          message: response.msg ? response.msg : '上传失败，请重新尝试',
          type: 'warning'
        });
      }
    },

    // 处理删除资源的场景
    handleRemove: function handleRemove(file, fileList) {
      // 存在response的话说明该素材已上传成功
      this.dialog.caseFileList = [];
      this.dialog.value.file_path = '';
    },
    handleCoverUploadSuccess: function handleCoverUploadSuccess(response, file, fileList) {
      // 只有在上传弹框是可视的情况下才执行后续逻辑
      if (!this.dialog.config.visible) return;
      if (response.code === 0) {
        // 当上传的图片都成功之后，为file_path赋值
        this.dialog.coverFileList = [{
          name: response.data.origin_name,
          url: response.data.url
        }];
        this.dialog.value.thumb_url = response.data.file_path;
      } else {
        console.log(file);
        file.status = 'fail';
        this.$message({
          message: response.msg ? response.msg : '上传失败，请重新尝试',
          type: 'warning'
        });
      }
    },

    // 删除封面资源
    handleCoverRemove: function handleCoverRemove(file, fileList) {
      // 存在response的话说明该素材已上传成功
      this.dialog.coverFileList = [];
      this.dialog.value.thumb_url = '';
    }
  }
};